import * as React from "react";
import i18n from "i18n";
import {
  Dialog,
  Button,
  DialogTitle,
  IconButton,
  DialogContent,
  DialogContentText,
  DialogActions,
  withStyles,
  Typography,
} from "@material-ui/core";
import { Close } from "@material-ui/icons";

const PropTypes = require("prop-types");
const styles = (theme) => ({
  whiteDialogPaper: {
    backgroundColor: "#F2F2F2 !important",
  },
  whiteDialogTitle: {
    backgroundColor: "#FFFFFF !important",
    borderBottomColor: "#737373 !important",
  },
  whiteDialogTitleText: {
    color: "#000000 !important",
  },
  whiteDialogContent: {
    color: "#212121 !important",
  },
  dialogTitle: {
    padding: "20px",
  },
  dialogTitleText: {
    color: "#f2f2f2",
    fontSize: "18px",
    margin: 0,
  },
  dialogContent: {
    padding: 0,
    color: "#a6a6a6",
    fontSize: "16px",
    margin: 0,
  },
  confirmButton: {
    color: "#ABC200",
  },
  confirmButtonInverse: {
    color: "#ABC200",
    order: 1,
  },
  closeIcon: {
    right: "20px",
    top: "14px",
  },
});

type IProps = {
  classes: any;
  open: boolean;
  title: string;
  contentText: string;
  onClose: any;
  onClickConfirm: any;
  enableCloseButton?: boolean;
  inverseButtons?: boolean;
  buttonConfirmLabel?: string;
  buttonConfirmColor?: string;
  buttonCancelLabel?: string;
  whiteTheme?: boolean;
};

const DialogModal = (props: IProps) => {
  const { classes } = props;
  const whiteTheme = true;

  function handleClickClose() {
    props.onClose();
  }

  function handleClickConfirm() {
    props.onClickConfirm();
    props.onClose();
  }

  return (
    <Dialog
      open={props.open}
      onClose={handleClickClose}
      classes={whiteTheme ? { paper: classes.whiteDialogPaper } : {}}
      aria-labelledby="draggable-dialog-title"
      disableBackdropClick={true}
      disableEscapeKeyDown={true}
    >
      <DialogTitle
        id="draggable-dialog-title"
        className={
          whiteTheme
            ? classes.dialogTitle + " " + classes.whiteDialogTitle
            : classes.dialogTitle
        }
      >
        <Typography
          className={
            whiteTheme
              ? classes.dialogTitleText + " " + classes.whiteDialogTitleText
              : classes.dialogTitleText
          }
        >
          {props.title}
        </Typography>
        {props.enableCloseButton && (
          <IconButton
            onClick={handleClickClose}
            className={classes.closeIcon}
            style={{ position: "absolute" }}
          >
            <Close fontSize="small" />
          </IconButton>
        )}
      </DialogTitle>

      <DialogContent>
        <DialogContentText
          className={
            whiteTheme
              ? classes.dialogContent + " " + classes.whiteDialogContent
              : classes.dialogContent
          }
        >
          {props.contentText}
        </DialogContentText>
      </DialogContent>

      <DialogActions>
        <Button
          className={
            props.inverseButtons
              ? classes.confirmButtonInverse
              : classes.confirmButton
          }
          autoFocus
          onClick={handleClickConfirm}
          style={
            props.buttonConfirmColor ? { color: props.buttonConfirmColor } : {}
          }
        >
          {props.buttonConfirmLabel || i18n.confirm}
        </Button>
        <Button onClick={handleClickClose} color="secondary">
          {props.buttonCancelLabel || i18n.cancel}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

DialogModal.propTypes = {
  onClose: PropTypes.func,
  onClickConfirm: PropTypes.func,
};

export default withStyles(styles)(DialogModal);



// WEBPACK FOOTER //
// ./src/common/components/DialogModal.tsx